import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=407f6ec3&"
import script from "./SearchBox.vue?vue&type=script&lang=js&"
export * from "./SearchBox.vue?vue&type=script&lang=js&"
import style0 from "./SearchBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../usr/lib/app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/lib/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407f6ec3')) {
      api.createRecord('407f6ec3', component.options)
    } else {
      api.reload('407f6ec3', component.options)
    }
    module.hot.accept("./SearchBox.vue?vue&type=template&id=407f6ec3&", function () {
      api.rerender('407f6ec3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "shared/site/patterns/vue/components/SearchBox.vue"
export default component.exports